<template>
  <div class='cake-page'>
    <img class='cake-bg' src='@/assets/img/cake/bg-cake.jpg' alt='' />
    <div class='content-section'>
      <div class='grid-section'>
        <div class='grid-item' @click='handleBindClick'>
          <img src='@/assets/img/cake/ic-bind.jpg' alt='' />
        </div>
        <div class='grid-item' @click='handleCardClick'>
          <img src='@/assets/img/cake/ic-coupon.jpg' alt='' />
        </div>
        <div class='grid-item' @click='handleOrderClick'>
          <img src='@/assets/img/cake/ic-order.jpg' alt='' />
        </div>
      </div>
      <div class='banner-section' @click='handleBanner3Click'>
        <img src='@/assets/img/cake/img-banner3.gif' alt='' />
      </div>
      <div class='banner-section' @click='handleBanner1Click'>
        <img src='@/assets/img/cake/img-banner1.gif' alt='' />
      </div>
      <div class='banner-section' @click='handleBanner2Click'>
        <img src='@/assets/img/cake/img-banner2.gif' alt='' />
      </div>
      <div class='tips-section'>
        <img src='@/assets/img/cake/img-tips.png' alt='' />
      </div>
    </div>
  </div>
</template>

<script>
import apiConfig from '@/config'

export default {
  name: 'MtCake',
  data() {
    return {}
  },
  created() {
  },
  methods: {
    // 绑定
    handleBindClick() {
      window.location.href = `${apiConfig.baseURL}/etonmall_h5/cardManager/bindCardPage.do`
    },
    // 券包
    handleCardClick() {
      window.location.href = `${apiConfig.baseURL}/etonmall_h5/cardManager/myCard.do`
    },
    // 订单
    handleOrderClick() {
      window.location.href = `${apiConfig.shopUrl}/shopmall/orderList?pageType=ecton_app&appTypes=%5B1000009,1000010,1000012%5D`
    },
    // 团购
    handleBanner1Click() {
      window.location.href = `${apiConfig.baseURL}/plat-web/fulaili/cakeH5InvokeLogin`
    },
    // 外卖
    handleBanner2Click() {
      window.location.href = `${apiConfig.baseURL}/plat-web/meituanTakeaway/h5InvokeLogin?scene=dessert`
    },
    // 蛋糕
    handleBanner3Click() {
      window.location.href = `${apiConfig.baseURL}/plat-web/uncleCake/h5InvokeLogin`
    }
  }
}
</script>

<style lang='scss' scoped>
.cake-page {
  width: 100%;
  position: relative;
}

.cake-bg {
  width: 100%;
  min-height: 100vh;
  height: auto;
  display: block;
}

.content-section {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.grid-section {
  display: flex;
  justify-content: space-between;
  padding: 0.1rem 0;
  margin: 2.1rem 0.05rem 0;
  background: #ffffff;
  border-radius: 0.05rem;

  .grid-item {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    &:not(:last-child)::after {
      content: '';
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 1px;
      height: 0.4rem;
      background: #e5e5e5;
    }

    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }
}

.banner-section {
  margin: 0.1rem 0.05rem 0;

  img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: .05rem;
  }
}

.tips-section {
  margin-top: 0.1rem;

  img {
    width: 100%;
    height: auto;
    display: block;
  }
}
</style>
